import { FiCalendar, FiMessageCircle, FiUsers } from "react-icons/fi";
import { PrimaryButton } from "~/components/Button";
import { Text } from "~/components/Text";

type BottomCTAProps = {
  clubName: string;
  onJoin: () => void;
};

export function BottomCTA({ clubName, onJoin }: BottomCTAProps) {
  return (
    <section className="relative mt-12 overflow-hidden rounded-xl bg-butter-pink px-6 py-12 sm:px-12 sm:py-16 lg:mt-24">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full bg-white/40 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-16 -left-16 h-72 w-72 rounded-full bg-butter-lime/40 blur-3xl"
      />
      <div className="relative mx-auto flex max-w-2xl flex-col items-center gap-5">
        <Text
          variant="primary"
          size="md"
          as="h2"
          color="light"
          className="text-center"
        >
          {clubName} doesn&apos;t stop between events
        </Text>
        <ul className="grid w-full grid-cols-1 divide-y divide-butter-cream-light/25 py-2 text-center text-butter-cream-light sm:grid-cols-3 sm:divide-x sm:divide-y-0">
          <li className="flex flex-row items-center justify-center gap-2 px-2 py-2.5 sm:flex-col sm:gap-1.5 sm:py-0">
            <FiMessageCircle size={18} aria-hidden />
            <Text as="span" variant="secondary" size="md" color="light">
              Join the club&apos;s chats
            </Text>
          </li>
          <li className="flex flex-row items-center justify-center gap-2 px-2 py-2.5 sm:flex-col sm:gap-1.5 sm:py-0">
            <FiCalendar size={18} aria-hidden />
            <Text as="span" variant="secondary" size="md" color="light">
              First access to plans
            </Text>
          </li>
          <li className="flex flex-row items-center justify-center gap-2 px-2 py-2.5 sm:flex-col sm:gap-1.5 sm:py-0">
            <FiUsers size={18} aria-hidden />
            <Text as="span" variant="secondary" size="md" color="light">
              Connect with members
            </Text>
          </li>
        </ul>
        <PrimaryButton
          theme="white"
          onClick={onJoin}
          className="!w-auto !px-9 !py-3.5 font-bold !text-butter-pink"
        >
          Join the club
        </PrimaryButton>
      </div>
    </section>
  );
}
